import type { SseStatus } from "@/api/sse";

/** The live status dot's colours: LiveToggle and the phone top bar's range chip. */
export const LIVE_DOT: Record<SseStatus, string> = {
  off: "bg-neutral",
  connecting: "bg-warn",
  open: "bg-ok",
  stale: "bg-danger",
};
